var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Component, VueType } from '../core';
import './binge.style.scss';
import BingeItem from './BingeItem';
import RecChannel from '../common/rec/RecChannel';
import { IBingeState } from '../../store/BingeState';
import { domEvent } from '../../../common/scroll';
import { checkLogin } from '../../../common/decorators';
let Binge = class Binge extends VueType {
    get hasData() {
        return this.state.bingeWatchList.length;
    }
    created() {
    }
    mounted() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.state.loadData(true);
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            const self = this;
            $(this.$el).on('click', '[data-del]', function (e) {
                e.stopPropagation();
                const $el = $(this);
                const attentKey = $el.data('del');
                self.state.delSingleBinge(attentKey);
                return false;
            });
            domEvent.bottom.on(this.loadMore);
        });
    }
    activated() {
        domEvent.bottom.on(this.loadMore);
    }
    deactivated() {
        domEvent.bottom.off(this.loadMore);
    }
    beforeDestroy() {
        domEvent.bottom.off(this.loadMore);
    }
    loadMore() {
        if (txv.login.isLogin()) {
            this.state.loadData(false);
        }
    }
    render() {
        let dom = null;
        if (this.hasData) {
            dom = <div class="binge_list">
                {this.state.bingeWatchList.map(item => { var _a; return <BingeItem data={item} key={(_a = item.itemParams) === null || _a === void 0 ? void 0 : _a.attentKey}/>; })}
            </div>;
        }
        else if (this.state.hasFetched || !txv.login.isLogin()) {
            dom = <RecChannel title="您的在追片单暂无内容,不如试试这些专属推荐"></RecChannel>;
        }
        return <div>{dom}</div>;
    }
};
__decorate([
    IBingeState
], Binge.prototype, "state", void 0);
__decorate([
    checkLogin
], Binge.prototype, "created", null);
Binge = __decorate([
    Component
], Binge);
export default Binge;
